import { useLazyLoadQuery } from 'react-relay';

import { bznavRefundUserPhoneQuery } from '@/__generated__/bznavRefundUserPhoneQuery.graphql';
import { bznavRefundUserPhone } from '@/graphql/query/tax-refund/bznav-refund';

export const useBznavRefundUserPhone = () => {
  const result = useLazyLoadQuery<bznavRefundUserPhoneQuery>(bznavRefundUserPhone, {});

  return result.bznavRefund?.user?.phone;
};
